export default {
  avatar: {
    width: 48,
    height: 48,
    borderRadius: 99999
  }
}